import { gql } from '__generated__';

export default gql(`
  query GetEvents($project_id: ID!, $page: Int, $per_page: Int, $search: String) {
    project(id: $project_id) {
      id
      events(page: $page, per_page: $per_page, search: $search) {
        data {
          id
          title
          location {
            id
            title
            description
            address
            country
            coordinates
          }
          logo {
            id
            url
          }
          start_date
          end_date
          registrations_count
          teams_count
          allow_teams
          active
          checkout_url
        }
        current_page
        last_page
        per_page
        total
      }
      all_events: events {
        total
      }
    }
  }
`);
